<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed"
  id="sidebar1"
  visible
>
  <c-sidebar-brand
    
    [brandFull]="{
      src: 'assets/img/brand/dhabilogo.png',
      width: 220,
      height: 50,
      alt: 'CoreUI Logo'
    }"
    [brandNarrow]="{
      src: 'assets/img/brand/coreui-signet-white.svg',
      width: 46,
      height: 46,
      alt: 'CoreUI Logo'
    }"
    [routerLink]="[]"
  />

  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav [navItems]="navigationMenu"  />
  </ng-scrollbar>
  <c-sidebar-toggler
    *ngIf="!sidebar1.narrow"
    toggle="unfoldable"
    cSidebarToggle="sidebar1"
  />
</c-sidebar>

<!--aside-->
<app-default-aside style="display: none;" />

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-default-header class="mb-4 d-print-none header header-sticky" position="sticky" sidebarId="sidebar1" />
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <c-container breakpoint="lg" class="h-auto main-css" >
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>
